(function() {
	'use strict';
	
	angular.module('app.core').filter('ageInDays', function() {
		return function(input) {
			var m = moment(input);
			var now = new moment();
			return now.diff(m, 'days');
		};
	});
})();
